<template>
  <ItemTitle type="baopin" class="physical-home-hot-list-container">
    <!-- 标题 -->
    <template v-slot:header>
      <img src="../imgs/home_baopin_logo.png" alt="">
      <p>爆品推荐</p>
    </template>

    <!-- 内容 -->
    <!-- <ul class="list" v-loading="isLoading">
      <HomeItem v-for="(item, index) in hotList" :key="index" :item="item"/>
    </ul> -->
    <div v-loading="isLoading">
      <md-scroll-view ref="jingPinScrollView" :scrolling-y="false" :touch-angle="80" :is-prevent="false">
        <ul class="list" v-loading="isLoading">
          <HomeItem v-for="(item, index) in hotList" :key="index" :item="item" />
        </ul>
      </md-scroll-view>
    </div>
  </ItemTitle>
</template>

<script>
import { getYouZanKeGoods } from "@/api/distribution";
import ItemTitle from "./itemTitle";
import HomeItem from "./homeItem";

export default {
  data() {
    return {
      isLoading: false,
      listParams: {
        pageNum: 1,
        pageSize: 10,
        categoryId: '',
        titleLike: '',
        orderBy: '',
        orderFlag: '',
        source: '',
        directionalFlag: false,
        minPrice: '',
        maxPrice: '',
        minCommissionRate: '',
        maxCommissionRate: '',
        hasDocument: false,
        extraLabel: 2, //传2 为爆品推荐
      },
      hotTotal: 0, //爆品总数
      hotList: [], //爆品推荐     
    }
  },
  methods: {
    load() {
      this.isLoading = true;
      getYouZanKeGoods(this.listParams).then(res => {
        if (res.success) {
          this.hotList = res.data.goodList || [];
          this.hotTotal = res.data.count || 0;
          this.$refs.jingPinScrollView.reflowScroller();
          this.isLoading = false;
        }
      })
    }
  },
  components: {
    ItemTitle,
    HomeItem
  },
  created() {
    this.load();
  }
}

</script>

<style lang="scss" scoped>
.physical-home-hot-list-container {
  .list {
    display: flex;
    // flex-wrap: wrap;
    // justify-content: space-between
  }
}
</style>